import { beneficiaryConstants } from "actions/types";
import { map } from "lodash";
import type { Beneficiary } from "types/models";
import type {
  BeneficiaryState,
  BeneficiaryWithAddressParts,
} from "types/state";

interface BeneficiaryAction {
  type: string;
  data?: unknown;
}

const initialState: BeneficiaryState = {
  beneficiaries: [],
  succesfullyUpdated: false,
  successfullyDeleted: false,
};

function formatBeneficiaries(
  beneficiaries: unknown
): BeneficiaryWithAddressParts[] {
  return map(
    beneficiaries as Array<Beneficiary & { __typename?: string }>,
    (beneficiary) => {
      // graphql adds __typename to objects and can cause unintended side effects
      const { __typename, ...restOfBeneficiary } = beneficiary; //eslint-disable-line @typescript-eslint/no-unused-vars
      const streetAddress = beneficiary.streetAddress as string[];
      return {
        ...restOfBeneficiary,
        address1: streetAddress[0],
        address2: streetAddress[1],
      };
    }
  );
}

export function beneficiary(
  state: BeneficiaryState = initialState,
  action: BeneficiaryAction
): BeneficiaryState {
  switch (action.type) {
    case beneficiaryConstants.GET_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        beneficiaries: formatBeneficiaries(action.data),
      };

    case beneficiaryConstants.UPDATE_BENEFICIARIES_REQUEST:
      return { ...state, succesfullyUpdated: false };
    case beneficiaryConstants.UPDATE_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        succesfullyUpdated: true,
        beneficiaries: formatBeneficiaries(action.data),
      };

    case beneficiaryConstants.DELETE_BENEFICIARIES_REQUEST:
      return { ...state, successfullyDeleted: false };

    case beneficiaryConstants.DELETE_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        successfullyDeleted: true,
        beneficiaries: [],
      };

    default:
      return state;
  }
}
